module.exports = __webpack_public_path__ + "img/fi-rr-surfing.78c48380.svg";